import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import './Header.css';

const Header = ({ onPlatformSelect, selectedPlatform }) => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  // Lock body scroll when menu is open
  useEffect(() => {
    if (mobileMenuOpen) {
      document.body.classList.add('menu-open');
      document.body.style.overflow = 'hidden';
    } else {
      document.body.classList.remove('menu-open');
      document.body.style.overflow = '';
    }
    
    return () => {
      document.body.classList.remove('menu-open');
      document.body.style.overflow = '';
    };
  }, [mobileMenuOpen]);

  const handleClick = (e, platform) => {
    e.preventDefault();
    e.stopPropagation();
    
    // Close menu first
    setMobileMenuOpen(false);
    
    // Then handle platform selection
    if (onPlatformSelect) {
      onPlatformSelect(platform);
    }
    
    // Scroll to hero section after menu closes
    setTimeout(() => {
      const heroSection = document.querySelector('.hero');
      if (heroSection) {
        heroSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }, 300);
  };

  const toggleMobileMenu = (e) => {
    e.stopPropagation();
    setMobileMenuOpen(!mobileMenuOpen);
  };

  const closeMobileMenu = (e) => {
    if (e) {
      e.stopPropagation();
    }
    setMobileMenuOpen(false);
  };

  const handleNavLinkClick = (e) => {
    // Don't prevent default for Link components
    closeMobileMenu();
  };

  return (
    <header className="header">
      <div className="header-container">
        <Link to="/" className="logo" onClick={closeMobileMenu}>
          <div className="logo-icon">
            <svg className="download-icon" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M12 3V16M12 16L7 11M12 16L17 11" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
              <path d="M3 17V19C3 20.1046 3.89543 21 5 21H19C20.1046 21 21 20.1046 21 19V17" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round"/>
            </svg>
          </div>
          <span className="logo-text">YT DOWN</span>
        </Link>
        
        {/* Hamburger Menu Button */}
        <button 
          className={`hamburger ${mobileMenuOpen ? 'active' : ''}`}
          onClick={toggleMobileMenu}
          aria-label="Toggle menu"
          aria-expanded={mobileMenuOpen}
        >
          <span className="hamburger-line"></span>
          <span className="hamburger-line"></span>
          <span className="hamburger-line"></span>
        </button>

        {/* Navigation Menu */}
        <nav className={`nav ${mobileMenuOpen ? 'mobile-open' : ''}`}>
          <div 
            className="nav-overlay" 
            onClick={closeMobileMenu}
            role="button"
            tabIndex={-1}
            aria-label="Close menu"
          ></div>
          <div className="nav-content">
            <Link 
              to="/" 
              className="nav-link" 
              onClick={handleNavLinkClick}
            >
              <span className="nav-icon">🏠</span>
              Home
            </Link>
            <a 
              href="#tiktok" 
              className={`nav-link ${selectedPlatform === 'tiktok' ? 'active' : ''}`}
              onClick={(e) => handleClick(e, 'tiktok')}
            >
              <span className="nav-icon">🎵</span>
              TikTok Videos
            </a>
            <a 
              href="#youtube" 
              className={`nav-link ${selectedPlatform === 'youtube' ? 'active' : ''}`}
              onClick={(e) => handleClick(e, 'youtube')}
            >
              <span className="nav-icon">▶️</span>
              YouTube Videos
            </a>
            <Link 
              to="/about" 
              className="nav-link" 
              onClick={handleNavLinkClick}
            >
              <span className="nav-icon">ℹ️</span>
              About
            </Link>
            <Link 
              to="/contact" 
              className="nav-link" 
              onClick={handleNavLinkClick}
            >
              <span className="nav-icon">✉️</span>
              Contact
            </Link>
          </div>
        </nav>
      </div>
    </header>
  );
};

export default Header;
